import React, { Fragment } from 'react';
import { toast } from 'react-toastify';
import Breadcrumb from '../common/breadcrumb';
import {Redirect} from 'react-router';
import { MDBDataTableV5 } from 'mdbreact';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faServer, faPhone } from '@fortawesome/free-solid-svg-icons'
import { Typeahead } from 'react-bootstrap-typeahead';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import '../../assets/scss/app-styles/users.scss'


class Summary extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            newRecordClicked: false,
            profileIdSelected: null,
            style: 'custom-spinner',
            loading: true,
            domainList: [],
		    backToIndex: false,
        };
    }
    headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    }

    componentDidMount(){
        if(JSON.parse(localStorage.getItem('creds')).cloud_id !== "CREXDEMO"){
            this.setState({backToIndex: true});
            return;
        }
        this.refreshData();
    }

    refreshData = () => {
        this.setState({style: 'custom-spinner'});
        const payLoad = {
            cloud_id: JSON.parse(localStorage.getItem('creds')).cloud_id
        };

        axios.post(`${process.env.REACT_APP_API_URL}accountsSummary`, payLoad, this.headers)
        .then(response=>{
            this.createDataTable(response.data);
            this.setState({style: 'custom-spinner-hide'});
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({style: 'custom-spinner-hide'});
        });
    }

    createDataTable = (dataFromApi) => {

        let columns =[
            {
                label: 'Id',
                field: 'id',
            },
            {
                label: 'Subscriber',
                field: 'cloud_id',
            },
            {
                label: 'User Login',
                field: 'cloud_username',
            },
            {
                label: 'Proxy',
                field: 'proxy',
            },
            {
                label: 'Outbound Proxy Host',
                field: 'outbound_proxy_host',
            },
            {
                label: 'Transport',
                field: 'transport',
            },
            {
                label: 'Username',
                field: 'account_username',
            },
            {
                label: 'Edit - Delete',
                field: 'edit',
                sort: 'disabled',
            }
        ];

        let dataModified = null;
        if(dataFromApi != null)
        {
            dataModified = dataFromApi.map((row)=>{
                return ({...row, edit:  <div className="edit-column">
                <i className="far fa-edit data-table-icon"
                    onClick={this.editHandler} data-id={row.id}></i> -
                <i className="far fa-trash-alt data-table-icon"
                    onClick={this.deleteHandler} data-id={row.id}></i>
                </div>
                });
            });

        }
        this.setState({dataTable: {columns: columns, rows: dataModified}});
        this.setState({loading: false});
    }



    deleteHandler = (event) =>{
        if(JSON.parse(localStorage.getItem('creds')).cloud_id !== "CREXDEMO"){
            toast.warn("Only Crexendo Engineering Support can delete this record");
            return;
        }
        confirmAlert({
            title: 'Are you sure you want to delete this account?',
            message: '',
            buttons: [
                {
                    label: 'Delete',
                    onClick: () => {
                        this.setState({style: 'custom-spinner'});
                        const payLoad = {
                            id : event.target.getAttribute("data-id"),
                            user_id: JSON.parse(localStorage.getItem('creds')).id,
                        };
                        this.setState({style: 'custom-spinner'});
                        axios.post(`${process.env.REACT_APP_API_URL}deleteAccountDetail`, payLoad, this.headers)
                        .then(response=>{
                            toast.success("Record Deleted");
                            this.setState({style: 'custom-spinner-hide'});
                            this.refreshData();
                        })
                        .catch(err=>{
                            toast.error(err.message);
                            this.setState({style: 'custom-spinner-hide'});
                        });
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                    }
                }
            ]
            
        });
    }

    editHandler = (event) =>{
        if(JSON.parse(localStorage.getItem('creds')).cloud_id !== "CREXDEMO"){
            toast.warn("Only Crexendo Engineering Support can edit this record");
            return;
        }
        this.setState({idSelected: event.target.getAttribute("data-id")})
        // will call the details compnent but with data id selected here as a prop

    }

    addNewHandler = (evt) => {
        evt.preventDefault();

        this.setState({newRecordClicked: true});

    }

    render() {

        let redirect = null;
        if(this.state.newRecordClicked){
            this.setState({newRecordClicked: false});
            redirect = <Redirect to = {{
                pathname: "/static_accounts/details",
                state: { id: null}
            }} />;

        }
        
        if(this.state.idSelected){
            this.setState({idSelected: null});
            redirect = <Redirect to = {{
                pathname: "/static_accounts/details",
                state: { id: this.state.idSelected}
            }} />;
        }

        if(this.state.backToIndex){
            redirect = <Redirect to = {{
                    pathname: "/dashboard"
            }} />;
        }

        return(
            <Fragment>
                <Breadcrumb parent="App" title="Static Accounts" />
                <div className={"loader-box " + this.state.style} >
                    <div className="loader">
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    </div>
                </div>
                {redirect}

                <div className = "MainIndex" style={{marginBottom: "100px"}}>
                    <div className="row" >
                        <div className="col-md-12">
                            <button style={{float:"right"}} onClick={this.addNewHandler} type="button"  className="btn btn-rounded-custom btn-primary table-btn" >Add New </button>
                        </div>
                        
                    </div>
                    <div className="users-table">
                        <MDBDataTableV5 hover entriesOptions={[10, 20, 30]} entries={10}
                        pagesAmount={4} data={this.state.dataTable} searchTop  searchBottom={false} />
                    </div>
                    
                </div>

            </Fragment>

        );

    }

}

export default Summary;
